import { Injectable } from '@angular/core';
import API, { graphqlOperation } from '@aws-amplify/api-graphql';
import {
  CreateFolderInput,
  CreateFolderMutation,
  CreateInvoiceInput,
  CreateInvoiceMutation,
  DeleteFolderInput,
  DeleteFolderMutation,
  DeleteInvoiceInput,
  DeleteInvoiceMutation,
  GetFolderQuery,
  ListFoldersQuery,
  ListInvoicesQuery,
  ModelFolderConditionInput,
  ModelInvoiceConditionInput,
  ModelInvoiceFilterInput,
  SubscriptionResponse,
  __SubscriptionContainer,
  ModelCreateFolderScanTaskInput,
  CreateFolderScanTaskMutation,
  ModelExportFolderInvoicesInput,
  ExportFolderInvoicesQuery,
  UpdateInvoiceInput,
  UpdateInvoiceMutation,
  ModelCreateTrialUserInput,
  CreateTrialUserMutation,
  ModelBulkInvoiceDeleteInput,
  BulkInvoiceDeleteMutation,
  ModelTemplateFilterInput,
  ListTemplatesQuery,
  ModelSortDirection,
  ListFoldersByClientIDQuery,
  ListFoldersByClientIDParentFolderIDPKQuery,
  ModelSubscriptionInvoiceFilterInput,
  ModelIDInput,
  ModelStringInput,
  ModelScanStatusInput,
  ModelBooleanInput,
  ModelIntInput,
  ListInvoicesByFolderIDQuery,
  ModelFloatKeyConditionInput,
  SearchableAllSortInput,
  FolderExportStatus,
  TF,
  SearchableFolderSortableFields,
  SearchableSortDirection,
  ModelFolderConnection,
  ModelFolderScanTaskConnection,
  FolderScanTask,
  ModelInvoiceConnection,
} from 'src/app/API.service';
import { Observable } from 'zen-observable-ts';
import { TemplateRunDialogComponent } from '../../../atoms/template-run-dialog/template-run-dialog/template-run-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomTemplatesComponent } from '../invoice-folder/custom-templates/custom-templates.component';
import { log } from 'console';
import { SortDirection } from 'aws-amplify';


export type SearchAllQuery = {
  __typename: "SearchAllOutput";
  folders?: Array<Folder | null> | null;
  invoices?: Array<InvoiceWithFolder | null> | null;
  nextToken?: string | null;
};

export type Folder = {
  __typename: "Folder";
  id: string;
  name: string;
  searchKeyword?: string | null;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  latestFolderInvoiceTaskID?: string | null;
  areThereMissingFields?: boolean | null;
  invoicesCount?: number | null;
  latestFolderInvoiceTask?: FolderScanTask | null;
  folderScanTasks?: ModelFolderScanTaskConnection | null;
  exportStatus?: FolderExportStatus | null;
  latestCompletedAt?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  parentFolderID?: string | null;
  parentFolder?: Folder | null;
  childFolders?: ModelFolderConnection | null;
  clientIDParentFolderIDPK?: string | null;
  isDeleted?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type InvoiceWithFolder = {
  __typename: "Invoice";
  id: string;
  name: string;
  folderID: string;
  clientID: string;
  extractedResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  index: number;
  extractedProductsResults?: string | null;
  isLatestScanIncludedProducts?: TF | null;
  rotateAngle: number;
  createdAt: string;
  updatedAt: string;
  nanonetsID?: string | null;
  title?: string | null;
  searchToken?: string | null;
  folder?: Folder | null;
};


export type _SubscriptionContainer = {
  onUpdateInvoice: OnUpdateInvoiceSubscription;
};

export type ModelFolderFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  clientID?: ModelIDInput | null;
  downloadLink?: ModelStringInput | null;
  status?: ModelScanStatusInput | null;
  latestFolderInvoiceTaskID?: ModelIDInput | null;
  areThereMissingFields?: ModelBooleanInput | null;
  invoicesCount?: ModelIntInput | null;
  latestCompletedAt?: ModelStringInput | null;
  searchKeyword?: ModelStringInput | null;
  and?: Array<ModelFolderFilterInput | null> | null;
  or?: Array<ModelFolderFilterInput | null> | null;
  not?: ModelFolderFilterInput | null;
};

export enum ScanStatus {
  INIT = 'INIT',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export type RunFolderInput = {
  invoiceName?: string | null;
  folderID?: string | null;
};

export type OnUpdateInvoiceSubscription = {
  __typename: 'Invoice';
  id: string;
  name: string;
  folderID: string;
  clientID: string;
  folder?: {
    __typename: 'Folder';
    id: string;
    name: string;
    clientID?: string | null;
    downloadLink?: string | null;
    status?: ScanStatus | null;
    latestFolderInvoiceTaskID?: string | null;
    areThereMissingFields?: boolean | null;
    invoicesCount?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  extractedResults?: string | null;
  extractedProductsResults?: string | null;
  missingFields?: string | null;
  thumbnailPath?: string | null;
  invoiceScanTasks?: {
    __typename: 'ModelInvoiceScanTaskConnection';
    nextToken?: string | null;
  } | null;
  rotateAngle: number;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateFolderSubscription = {
  __typename: 'Folder';
  id: string;
  name: string;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  createdAt: string;
  updatedAt: string;
  invoices?: {
    __typename: 'ModelInvoiceConnection';
    items: Array<{
      __typename: 'Invoice';
      id: string;
      name: string;
      folderID: string;
      createdAt: string;
      updatedAt: string;
      scans?: {
        __typename: 'ModelScanConnection';
        items: Array<{
          __typename: 'Scan';
          id: string;
          invoiceID?: string | null;
          executionTime?: string | null;
          workerID?: string | null;
          status?: ScanStatus | null;
          downloadLink?: string | null;
          createdAt: string;
          updatedAt: string;
        } | null>;
        nextToken?: string | null;
      } | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type RunFolderMutation = {
  __typename: 'Folder';
  id: string;
  name: string;
  clientID?: string | null;
  downloadLink?: string | null;
  status?: ScanStatus | null;
  createdAt: string;
  updatedAt: string;
  invoices?: {
    __typename: 'ModelInvoiceConnection';
    items: Array<{
      __typename: 'Invoice';
      id: string;
      name: string;
      folderID: string;
      createdAt: string;
      updatedAt: string;
      scans?: {
        __typename: 'ModelScanConnection';
        items: Array<{
          __typename: 'Scan';
          id: string;
          invoiceID?: string | null;
          executionTime?: string | null;
          workerID?: string | null;
          status?: ScanStatus | null;
          downloadLink?: string | null;
          createdAt: string;
          updatedAt: string;
        } | null>;
        nextToken?: string | null;
      } | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type CreateInvoiceUserAssignmentInput = {
  invoiceID: string;
  clientID: string;
  email: string;
  role?: string | null;
  notified?: TF | null;
};


export type DeleteInvoiceUserAssignmentInput = {
  id: string;
};

export type CreateInvoiceUserAssignmentMutation = {
  __typename: "InvoiceUserAssignment";
  id: string;
  invoiceID: string;
  email: string;
  createdAt: string;
  updatedAt: string;
};

export type DeleteInvoiceUserAssignmentMutation = {
  __typename: "InvoiceUserAssignment";
  id: string;
  invoiceID: string;
  clientID: string;
  email: string;
  role?: string | null;
  notified: TF;
  createdAt: string;
  updatedAt: string;
};

export type InvoiceUserAssignment = {
  __typename: "InvoiceUserAssignment";
  id: string;
  invoiceID: string;
  email: string;
  createdAt: string;
  updatedAt: string;
};

@Injectable({
  providedIn: 'root',
})
export class InvoicesService {
  constructor(private dialog: MatDialog) { }
  async ListInvoices(
    filter?: ModelInvoiceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoicesQuery> {
    const statement = `query ListInvoices($filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String) {
        listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            folderID
            scans {
              __typename
              items {
                __typename
                id
                invoiceID
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInvoicesQuery>response.data.listInvoices;
  }

  async ListTemplates(
    filter?: ModelTemplateFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListTemplatesQuery> {
    const statement = `query ListTemplates($filter: ModelTemplateFilterInput, $limit: Int, $nextToken: String) {
        listTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            productsEnabled
            description
            clientID
            template
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListTemplatesQuery>response.data.listTemplates;
  }


  // async SearchAll(
  //   keyword: string,
  //   limit: number = 1000,
  //   nextToken?: string,
  //   sort: Array<SearchableAllSortInput | null> = [{ field: SearchableFolderSortableFields.createdAt, direction: SearchableSortDirection.desc }] 
  // ): Promise<SearchAllQuery> {
  //   console.log("🔍 SearchAll called with:", { keyword, limit, nextToken, sort });

  //   const statement = `query SearchAll($keyword: String!, $limit: Int, $nextToken: String, $sort: [SearchableAllSortInput]) {
  //       searchAll(keyword: $keyword, limit: $limit, nextToken: $nextToken, sort: $sort) {
  //         __typename
  //         folders {
  //           __typename
  //           id
  //           name
  //           searchKeyword
  //           clientID
  //           downloadLink
  //           status
  //           latestFolderInvoiceTaskID
  //           areThereMissingFields
  //           invoicesCount
  //           exportStatus
  //           latestCompletedAt
  //           isLatestScanIncludedProducts
  //           createdAt
  //           updatedAt
  //         }
  //         invoices {
  //           __typename
  //           id
  //           name
  //           folderID
  //           clientID
  //           extractedResults
  //           missingFields
  //           thumbnailPath
  //           index
  //           extractedProductsResults
  //           isLatestScanIncludedProducts
  //           rotateAngle
  //           createdAt
  //           updatedAt
  //           nanonetsID
  //           title
  //           searchToken
  //           folder {
  //             __typename
  //             id
  //             name
  //             searchKeyword
  //             clientID
  //             downloadLink
  //             status
  //             latestFolderInvoiceTaskID
  //             areThereMissingFields
  //             invoicesCount
  //             exportStatus
  //             latestCompletedAt
  //             isLatestScanIncludedProducts
  //             createdAt
  //             updatedAt
  //           }
  //         }
  //         nextToken
  //       }
  //     }`;

  //   const gqlAPIServiceArguments: any = {
  //     keyword,
  //     limit, 
  //     sort
  //   };
  //   if (nextToken) {
  //     gqlAPIServiceArguments.nextToken = nextToken;
  //   }

  //   console.log("📤 Sending GraphQL request with arguments:", gqlAPIServiceArguments);

  //   try {
  //     const response = (await API.graphql(
  //       graphqlOperation(statement, gqlAPIServiceArguments)
  //     )) as any;

  //     console.log("✅ GraphQL response received:", response);

  //     const result = <SearchAllQuery>response.data.searchAll;
  //     console.log("📦 Length of results", (result.folders ?? []).length + (result.invoices ?? []).length);
  //     console.log("📦 Parsed search result:", result);

  //     return result;
  //   } catch (error) {
  //     console.error("❌ Error in SearchAll:", error);
  //     throw error;
  //   }
  // }



  async BulkInvoiceDelete(
    input?: ModelBulkInvoiceDeleteInput
  ): Promise<BulkInvoiceDeleteMutation> {
    const statement = `mutation BulkInvoiceDelete($input: ModelBulkInvoiceDeleteInput) {
        bulkInvoiceDelete(input: $input) {
          __typename
          result
          message
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <BulkInvoiceDeleteMutation>response.data.bulkInvoiceDelete;
  }

  OnUpdateFolderListener(
    clientID?: string
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, 'onUpdateFolder'>>
  > {
    const statement = `subscription OnUpdateFolder($clientID: String) {
        onUpdateFolder(clientID: $clientID) {
          __typename
          id
          name
          clientID
          downloadLink
          status
          latestFolderInvoiceTaskID
          areThereMissingFields
          isLatestScanIncludedProducts
          invoices {
            items {
              updatedAt
              name
              missingFields
              id
              rotateAngle,
              folderID
              extractedResults
              createdAt
              extractedProductsResults
              thumbnailPath
            }
          }
          latestFolderInvoiceTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            createdAt
            updatedAt
          }
          latestCompletedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, 'onUpdateFolder'>>
    >;
  }

  OnUpdateInvoiceListener(
    filter?: ModelSubscriptionInvoiceFilterInput,
    clientID?: string
  ): Observable<
    SubscriptionResponse<Pick<_SubscriptionContainer, 'onUpdateInvoice'>>
  > {
    const statement = `subscription OnUpdateInvoice($filter: ModelSubscriptionInvoiceFilterInput, $clientID: String) {
        onUpdateInvoice(filter: $filter, clientID: $clientID) {
          __typename
          id
          name
          folderID
          clientID
          folder {
            __typename
            id
            name
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            createdAt
            updatedAt
          }
          extractedResults
          missingFields
          thumbnailPath
          rotateAngle,
          extractedProductsResults
          invoiceScanTasks {
            __typename
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (clientID) {
      gqlAPIServiceArguments.clientID = clientID;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<_SubscriptionContainer, 'onUpdateInvoice'>>
    >;
  }

  async ExportFolderInvoices(
    input?: ModelExportFolderInvoicesInput
  ): Promise<ExportFolderInvoicesQuery> {
    const statement = `query ExportFolderInvoices($input: ModelExportFolderInvoicesInput) {
        exportFolderInvoices(input: $input) {
          __typename
          output {
            __typename
            fileName
            mimeType
            fileContent
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ExportFolderInvoicesQuery>response.data.exportFolderInvoices;
  }

  async RunFolder(input: Array<RunFolderInput>): Promise<RunFolderMutation> {
    const statement = `mutation RunFolder($input: [RunFolderInput!]!) {
        runFolder(input: $input) {
          __typename
          id
          name
          clientID
          downloadLink
          status
          createdAt
          updatedAt
          invoices {
            __typename
            items {
              __typename
              id
              name
              folderID
              createdAt
              updatedAt
              scans {
                __typename
                items {
                  __typename
                  id
                  invoiceID
                  executionTime
                  workerID
                  status
                  downloadLink
                  createdAt
                  updatedAt
                }
                nextToken
              }
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <RunFolderMutation>response.data.runFolder;
  }

  async GetFolder(
    id: string,
    limit?: number,
    nextToken?: string
  ): Promise<GetFolderQuery> {
    const statement = `query GetFolder($id: ID!, $limit: Int, $nextToken: String) {
        getFolder(id: $id) {
          __typename
          id
          name
          isLatestScanIncludedProducts
          clientID
          latestFolderInvoiceTaskID
          downloadLink
          status
          invoicesCount
          areThereMissingFields
          parentFolderID
          childFolders {
            items {
              __typename
              id
              name
              isLatestScanIncludedProducts
              clientID
              latestFolderInvoiceTaskID
              downloadLink
              status
              invoicesCount
              invoices(limit: 3000) {
                items {
                  updatedAt
                  rotateAngle
                  missingFields
                  extractedResults
                  extractedProductsResults
                  thumbnailPath
                  name
                  title
                  id
                  folderID
                  createdAt
                }
                nextToken
              }
              parentFolderID
              areThereMissingFields
              isPasswordProtected
              passwordHash
              latestCompletedAt
              createdAt
              updatedAt
            }
            nextToken
          }
          invoices (limit: $limit, nextToken: $nextToken, sortDirection: DESC) {
            items {
              updatedAt
              name
              title
              missingFields
              rotateAngle
              id
              folderID
              thumbnailPath
              extractedResults
              createdAt
              extractedProductsResults
              thumbnailPath
              nanonetsID
              
              nanonets {
                expiresAt
                fileID
                modelID
                redirectUrl
                previewUrl
              }
              invoiceUserAssignments {
                items {
                  id
                  email
                }
              }
            }
            nextToken
          }
          isPasswordProtected
          passwordHash
          createdAt
          updatedAt
          latestCompletedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
    };
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetFolderQuery>response.data.getFolder;
  }

  async GetFolderInvoicesIDs(
    id: string,
    limit?: number,
    nextToken?: string
  ): Promise<GetFolderQuery> {
    const statement = `query GetFolder($id: ID!, $limit: Int, $nextToken: String) {
        getFolder(id: $id) {
          invoices (limit: $limit, nextToken: $nextToken) {
              items {
                updatedAt
                missingFields
                extractedResults
                rotateAngle
                extractedProductsResults
                thumbnailPath
                name
                id
                folderID
                createdAt
              }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
    };
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetFolderQuery>response.data.getFolder;
  }

  async UpdateInvoice(
    input: UpdateInvoiceInput,
    condition?: ModelInvoiceConditionInput
  ): Promise<UpdateInvoiceMutation> {
    const statement = `mutation UpdateInvoice($input: UpdateInvoiceInput!, $condition: ModelInvoiceConditionInput) {
        updateInvoice(input: $input, condition: $condition) {
          __typename
          id
          name
          folderID
          folder {
            __typename
            id
            name
            clientID
            downloadLink
            status
            areThereMissingFields
            createdAt
            updatedAt
          }
          extractedResults
          rotateAngle
          extractedProductsResults
          missingFields
          invoiceScanTasks {
            __typename
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateInvoiceMutation>response.data.updateInvoice;
  }


  async UpdateInvoiceTitle(
    input: UpdateInvoiceInput,
    condition?: ModelInvoiceConditionInput
  ): Promise<UpdateInvoiceMutation> {
    const statement = `mutation UpdateInvoice($input: UpdateInvoiceInput!, $condition: ModelInvoiceConditionInput) {
        updateInvoice(input: $input, condition: $condition) {
          __typename
          id
          title
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateInvoiceMutation>response.data.updateInvoice;
  }

  async CreateFolderScanTask(
    input: ModelCreateFolderScanTaskInput
  ): Promise<CreateFolderScanTaskMutation> {
    const statement = `mutation CreateFolderScanTask($input: ModelCreateFolderScanTaskInput!) {
        createFolderScanTask(input: $input) {
          __typename
          id
          isScanIncludedProducts
          folderID
          folder {
            __typename
            id
            name
            clientID
            downloadLink
            status
            areThereMissingFields
            createdAt
            updatedAt
          }
          clientID
          client {
            __typename
            id
            username
            email
            company
            phone
            address
            city
            createdAt
            updatedAt
          }
          taskCount
          processedTaskCount
          executionTime
          logMessages
          status
          extractedResults
          missingFieldsCount
          invoiceScanTasks {
            __typename
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateFolderScanTaskMutation>response.data.createFolderScanTask;
  }

  async CreateFolder(
    input: CreateFolderInput,
    condition?: ModelFolderConditionInput
  ): Promise<CreateFolderMutation> {
    const statement = `mutation CreateFolder($input: CreateFolderInput!, $condition: ModelFolderConditionInput) {
        createFolder(input: $input, condition: $condition) {
          __typename
          id
          name
          isLatestScanIncludedProducts
          clientID
          downloadLink
          status
          latestFolderInvoiceTaskID
          areThereMissingFields
          invoicesCount
          parentFolderID
          invoices {
            __typename
            nextToken
          }
          latestFolderInvoiceTask {
            __typename
            id
            folderID
            clientID
            taskCount
            processedTaskCount
            failedTaskCount
            executionTime
            logMessages
            status
            extractedResults
            missingFieldsCount
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateFolderMutation>response.data.createFolder;
  }

  async ListFolders(
    filter?: ModelFolderFilterInput,
    limit?: 1000,
    nextToken?: string
  ): Promise<ListFoldersQuery> {
    const statement = `query ListFolders($filter: ModelFolderFilterInput, $limit: Int, $nextToken: String) {
      listFolders(filter: $filter, limit: $limit, nextToken: $nextToken) {
        __typename
        items {
          __typename
          id
          name
          isLatestScanIncludedProducts
          latestFolderInvoiceTaskID
          clientID
          downloadLink
          areThereMissingFields
          status
          invoices(limit: 3000) {
            items {
              updatedAt
              rotateAngle
              missingFields
              extractedResults
              extractedProductsResults
              name
              id
              folderID
              createdAt
            }
          }
          createdAt
          updatedAt
        }
        nextToken
      }
    }
    `;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFoldersQuery>response.data.listFolders;
  }

  async ListFoldersByClientID(
    clientID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelFolderFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFoldersByClientIDQuery> {
    const statement = `query ListFoldersByClientID($clientID: ID!, $sortDirection: ModelSortDirection, $filter: ModelFolderFilterInput, $limit: Int, $nextToken: String) {
        listFoldersByClientID(clientID: $clientID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            isLatestScanIncludedProducts
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            createdAt
            updatedAt
            latestCompletedAt
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            isPasswordProtected
            passwordHash
            invoices(limit: 3000) {
              items {
                updatedAt
                rotateAngle
                missingFields
                extractedResults
                extractedProductsResults
                thumbnailPath
                name
                id
                folderID
                createdAt
                title
              }
            }
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientID,
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFoldersByClientIDQuery>response.data.listFoldersByClientID;
  }


  async ListFoldersByClientIDParentFolderIDPK(
    clientIDParentFolderIDPK: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelFolderFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFoldersByClientIDParentFolderIDPKQuery> {
    const statement = `query ListFoldersByClientIDParentFolderIDPK($clientIDParentFolderIDPK: String!, $sortDirection: ModelSortDirection, $filter: ModelFolderFilterInput, $limit: Int, $nextToken: String) {
        listFoldersByClientIDParentFolderIDPK(
          clientIDParentFolderIDPK: $clientIDParentFolderIDPK
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            name
            searchKeyword
            clientID
            downloadLink
            status
            latestFolderInvoiceTaskID
            areThereMissingFields
            invoicesCount
            exportStatus
            latestCompletedAt
            invoices(limit: 3000) {
              items {
                updatedAt
                rotateAngle
                missingFields
                extractedResults
                extractedProductsResults
                thumbnailPath
                name
                id
                folderID
                createdAt
                title
              }
              nextToken
            }
            isLatestScanIncludedProducts
            parentFolderID
            clientIDParentFolderIDPK
            isDeleted
            isPasswordProtected
            passwordHash
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      clientIDParentFolderIDPK
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFoldersByClientIDParentFolderIDPKQuery>(
      response.data.listFoldersByClientIDParentFolderIDPK
    );
  }


  async ListInvoicesByFolderID(
    folderID: string,
    index?: ModelFloatKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelInvoiceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInvoicesByFolderIDQuery> {
    console.log("📡 Sending GraphQL query to backend...");
    console.log("📁 Folder ID:", folderID);
    console.log("🔢 Index:", index);
    console.log("🔄 Sort Direction:", sortDirection);
    console.log("🔍 Filter Applied:", JSON.stringify(filter, null, 2));
    console.log("📦 Limit:", limit);
    console.log("🔄 Next Token:", nextToken);

    const statement = `query ListInvoicesByFolderID($folderID: ID!, $index: ModelFloatKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String) {
          listInvoicesByFolderID(folderID: $folderID, index: $index, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            __typename
            items {
              __typename
              id
              name
              folderID
              clientID
              extractedResults
              missingFields
              thumbnailPath
              index
              extractedProductsResults
              isLatestScanIncludedProducts
              rotateAngle
              createdAt
              updatedAt
              nanonetsID
              title
              searchToken
            }
            nextToken
          }
        }`;

    const gqlAPIServiceArguments: any = { folderID };
    if (index) gqlAPIServiceArguments.index = index;
    if (sortDirection) gqlAPIServiceArguments.sortDirection = sortDirection;
    if (filter) gqlAPIServiceArguments.filter = filter;
    if (limit) gqlAPIServiceArguments.limit = limit;
    if (nextToken) gqlAPIServiceArguments.nextToken = nextToken;

    console.log("📜 Query Arguments:", JSON.stringify(gqlAPIServiceArguments, null, 2));

    try {
      const response = (await API.graphql(
        graphqlOperation(statement, gqlAPIServiceArguments)
      )) as any;

      console.log("✅ GraphQL Response Received");
      console.log("📃 Invoices Retrieved:", response.data.listInvoicesByFolderID?.items?.length || 0);
      console.log("📜 First Invoice Data:", response.data.listInvoicesByFolderID?.items?.[0] || "No data");
      console.log("🔄 New Next Token:", response.data.listInvoicesByFolderID?.nextToken || "No next token");

      return <ListInvoicesByFolderIDQuery>response.data.listInvoicesByFolderID;
    } catch (error) {
      console.error("❌ GraphQL Query Error:", error);
      throw error; // Re-throwing the error for further debugging
    }
  }


  async getAllFoldersByListFolders(
    filter?: ModelFolderFilterInput,
    limit?: 1000
  ) {
    let nextToken: string | undefined = undefined;
    let folders: any = [];
    while (true) {
      const result: any = await this.ListFolders(filter, limit, nextToken);
      folders = [...folders, ...result.items];
      nextToken = result.nextToken;

      if (!nextToken) {
        break;
      }
    }
    return folders;
  }

  // async getAllFolders(clientID: string, parentFolderID: string = "", nextToken?: string, limit?: number) {
  //   return await this.ListFoldersByClientIDParentFolderIDPK(
  //     `${clientID}#${parentFolderID}`,
  //     undefined,
  //     undefined,
  //     100,
  //     nextToken ? nextToken : undefined
  //   );
  // }

  async getAllFolders(clientID: string, nextToken?: string, limit: number = 10000) {
    return await this.ListFoldersByClientID(
      clientID,
      undefined,
      undefined,
      limit,
      nextToken
    );
  }


  async getFilteredFolders(clientID: string, keyword?: string) {
    return await this.ListFoldersByClientID(
      clientID,
      undefined,
      { searchKeyword: { contains: keyword } },
      10000
    );
  }

  async getFilteredInvoices(
    folderID: string,
    keyword?: string
  ) {
    return await this.ListInvoicesByFolderID(
      folderID,
      undefined,
      ModelSortDirection.DESC,
      { searchToken: { contains: keyword } },
      10000
    );
  }

  async DeleteFolder(
    input: DeleteFolderInput,
    condition?: ModelFolderConditionInput
  ): Promise<DeleteFolderMutation> {
    const statement = `mutation DeleteFolder($input: DeleteFolderInput!, $condition: ModelFolderConditionInput) {
        deleteFolder(input: $input, condition: $condition) {
          __typename
          id
          name
          clientID
          invoices {
            __typename
            items {
              __typename
              id
              name
              folderID
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteFolderMutation>response.data.deleteFolder;
  }

  async DeleteInvoice(
    input: DeleteInvoiceInput,
    condition?: ModelInvoiceConditionInput
  ): Promise<DeleteInvoiceMutation> {
    const statement = `mutation DeleteInvoice($input: DeleteInvoiceInput!, $condition: ModelInvoiceConditionInput) {
        deleteInvoice(input: $input, condition: $condition) {
          __typename
          id
          name
          folderID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteInvoiceMutation>response.data.deleteInvoice;
  }

  async CreateInvoice(
    input: CreateInvoiceInput,
    condition?: ModelInvoiceConditionInput
  ): Promise<CreateInvoiceMutation> {
    const statement = `mutation CreateInvoice($input: CreateInvoiceInput!, $condition: ModelInvoiceConditionInput) {
        createInvoice(input: $input, condition: $condition) {
          __typename
          id
          name
          folderID
          clientID
          title
          extractedResults
          rotateAngle
          extractedProductsResults
          missingFields
          invoiceScanTasks {
            __typename
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateInvoiceMutation>response.data.createInvoice;
  }

  b64toBlob(b64Data: any, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  downloadExcelFile(data: ExportFolderInvoicesQuery) {
    const blob = this.b64toBlob(
      data.output?.fileContent,
      data.output?.mimeType as any
    );
    const linkSource = URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = data.output?.fileName as any;
    downloadLink.click();
  }

  stopDefault(e: Event) {
    e.stopPropagation();
  }

  openTemplateModal(event: any, folderID: any) {
    this.stopDefault(event);
    const dialogRef = this.dialog.open(TemplateRunDialogComponent, {
      width: '780px',
      height: '550px',
      panelClass: ['select-template-dialog'],
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (!!res && res?.action === 'run') {
        const input = {
          folderID,
          templateID: res.templateId,
          format: res.templateId === 'eLine' ? 'xml' : 'excel',
        };
        this.ExportFolderInvoices(input).then((data) => {
          this.downloadExcelFile(data);
        });
      }
    });
  }

  openTemplateDialog(item: any) {
    let duplicatedArray = JSON.parse(JSON.stringify(item.invoices.items));
    duplicatedArray.forEach((item: any, index: any, array: any) => {
      item.missingFields = JSON.parse(item.missingFields);
    });
    const dialogReg = this.dialog.open(CustomTemplatesComponent, {
      width: 'fit-content',
      height: 'fit-content',
      data: duplicatedArray,
    });
    dialogReg.afterClosed().subscribe((data) => {
      if (data) {
        if (data.event === 'skipAndDownload') {
          const dialogRef = this.dialog.open(TemplateRunDialogComponent, {
            width: '780px',
            height: '550px',
            panelClass: ['select-template-dialog'],
          });
          dialogRef.afterClosed().subscribe((res) => {
            if (!!res && res?.action === 'run') {
              const input = {
                folderID: item.id,
                templateID: res.templateId,
                format: res.templateId === 'eLine' ? 'xml' : 'excel',
              };
              this.ExportFolderInvoices(input).then((data) => {
                this.downloadExcelFile(data);
              });
            }
          });
        }
      }
    });
  }

  async CreateTrialUser(
    input?: ModelCreateTrialUserInput
  ): Promise<CreateTrialUserMutation> {
    const statement = `mutation CreateTrialUser($input: ModelCreateTrialUserInput!) {
      createTrialUser(input: $input) {
        id
      }
    }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response: any = await API.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
      authMode: 'API_KEY',
    });
    return response.data.createTrialUser as any;
  }

  updateInvoicesItems(object: any, updatedObjectData: any) {
    const updatedExtractedResults = updatedObjectData.updatedExtractedResults;

    for (const updatedItem of updatedExtractedResults) {
      const itemId = updatedItem.id;
      const index = object.invoices.items.findIndex(
        (item: any) => item.id === itemId
      );

      if (index !== -1) {
        // Update the "extractedResults" and "missingFields" properties
        object.invoices.items[index].extractedResults =
          updatedItem.extractedResults;
        object.invoices.items[index].missingFields = updatedItem.missingFields;
      }
    }

    return object;
  }

  async getInvoice(id: string): Promise<any> {
    const statement = `
query MyQuery($id: ID!) {
  getInvoice(id: $id) {
    clientID
    createdAt
    extractedProductsResults
    extractedResults
    folderID
    index
    isLatestScanIncludedProducts
    missingFields
    name
    rotateAngle
    thumbnailPath
    updatedAt
    nanonetsID
    nanonets {
      expiresAt
      fileID
      modelID
      redirectUrl
      previewUrl
    }
    id
  }
}


    
    `;
    const gqlAPIServiceArguments: any = {
      id: id,
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return response;
  }

  async generatePreviewUrl(id: string, redirectUrl: string): Promise<any> {
    const statement = `
mutation MyMutation($input: GeneratePreviewUrlInput!) {
  generatePreviewUrl(input: $input) {
    clientID
    extractedProductsResults
    createdAt
    extractedResults
    folderID
    id
    index
    isLatestScanIncludedProducts
    missingFields
    name
    nanonetsID
    rotateAngle
    thumbnailPath
    updatedAt
    nanonets {
      fileID
      expiresAt
      modelID
      previewUrl
      redirectUrl
    }
  }
}    `;
    const gqlAPIServiceArguments: any = {
      input: {
        invoiceID: id,
        redirectUrl,
      },
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return response;
  }

  async assignInvoiceToUser(input: CreateInvoiceUserAssignmentInput | Array<CreateInvoiceUserAssignmentInput>): Promise<Array<CreateInvoiceUserAssignmentMutation>> {
    const statement = `mutation CreateInvoiceUserAssignment($input: [CreateInvoiceUserAssignmentInput!]!) {
      createInvoiceUserAssignment(input: $input) {
        __typename
        id
        invoiceID
        invoice {
          __typename
          id
          name
          folderID
          clientID
        }
        clientID
        email
        role
        notified
        createdAt
        updatedAt
      }
    }`;

    const gqlAPIServiceArguments = {
      input: Array.isArray(input) ? input : [input]
    };

    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return response.data.createInvoiceUserAssignment;
  }

  async removeInvoiceAssignment(input: string | Array<string>): Promise<Array<DeleteInvoiceUserAssignmentMutation>> {
    const statement = `mutation DeleteInvoiceUserAssignment($input: [ID!]!) {
      deleteInvoiceUserAssignment(input: $input) {
        __typename
        id
      }
    }`;

    const gqlAPIServiceArguments = {
      input: Array.isArray(input) ? input : [input]
    };

    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return response.data.deleteInvoiceUserAssignment;
  }

  async SearchFolderInvoices(
    rootFolderID: string,
    keyword: string,
    limit: number = 100
  ): Promise<{ items: any[]; total: number }> {
    const statement = `query SearchFolderInvoices($rootFolderID: ID!, $keyword: String!, $limit: Int) {
      searchFolderInvoices(rootFolderID: $rootFolderID, keyword: $keyword, limit: $limit) {
        items {
          id
          title
          name
          thumbnailPath
          folderID
          createdAt
          updatedAt
          missingFields
          rotateAngle
          extractedResults
          extractedProductsResults
        }
        total
        nextToken
      }
    }`;
    const response = (await API.graphql(
      graphqlOperation(statement, { rootFolderID, keyword, limit })
    )) as any;
    return response.data.searchFolderInvoices;
  }
}
